import React from "react";

const GridBlock = {
  label: "Grid",
  fields: {
    numColumns: {
      type: "number",
      label: "Columns",
      min: 1,
      max: 12,
    },
    gap: {
      type: "number",
      label: "Gap (px)",
      min: 0,
    },
    items: {
      type: "slot",
    },
  },
  defaultProps: {
    numColumns: 3,
    gap: 24,
    items: [],
  },
  render: ({ numColumns, gap, items: Items, puck }) => {
    return (
      <Items
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${numColumns || 1}, 1fr)`,
          gap: `${gap ?? 24}px`,
          minHeight: puck?.isEditing ? "64px" : undefined,
        }}
      />
    );
  },
};

export default GridBlock;
